export default "__VITE_ASSET__BY2f3Etu__"